(function(){
  const drawer    = document.getElementById('mobileDrawer');
  const openBtn   = document.getElementById('menuToggle');
  const closeBtn  = document.getElementById('menuClose');
  const backdrop  = document.getElementById('menuBackdrop');
  const inner     = drawer?.querySelector('.c-drawer__inner');

  if(!drawer || !openBtn || !closeBtn || !backdrop || !inner) return;

  let lastFocus = null;

  function openDrawer(){
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    document.body.classList.add('menu-open');
    openBtn.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(()=> inner.focus(), 10);
  }

  function closeDrawer(){
    drawer.classList.remove('is-open');
    document.body.classList.remove('menu-open');
    openBtn.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (lastFocus) lastFocus.focus();
  }

  openBtn.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  backdrop.addEventListener('click', closeDrawer);

  // ESC to close
  document.addEventListener('keydown', (e)=>{
    if(e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  // simple focus trap
  inner.addEventListener('keydown', (e)=>{
    if(e.key !== 'Tab') return;
    const focusables = inner.querySelectorAll('a,button,input,select,textarea,[tabindex]:not([tabindex="-1"])');
    if(!focusables.length) return;
    const first = focusables[0];
    const last  = focusables[focusables.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });
})();
